import { render, staticRenderFns } from "./SolicitudVehiculoExport.vue?vue&type=template&id=63b64746"
import script from "./SolicitudVehiculoExport.vue?vue&type=script&lang=js"
export * from "./SolicitudVehiculoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports